import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/platformNews";
import Form from "./form";
import List from "./list";
import Show from "./show";

export default function AdminPlatformNews(props) {
    useEffect(() => {
        return () => props.clearParams("admin-platform-news");
    }, []);

    const {
        match,
        location,
        history,
        roles: { isRoot, isAdmin, isIntegrationManager },
    } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            title="Информирование пользователей"
                            nofilter
                            createBtnText="Создать новость"
                            canEditBooks={isRoot || isAdmin || isIntegrationManager}
                        />
                    )}
                />
                <Route
                    path={`${rootUrl}/:id`}
                    render={(rest) => <Show {...rest} transition="full" title="Новость" back={back} source={source} />}
                />
                <Route
                    path={`${match.path}/new`}
                    render={() => <Form {...props} title="Создать новость" back={back} submit={source.apply} />}
                />
            </Switch>
        </div>
    );
}
